import { Form, Select } from "antd";
import useElements from "../../hooks/useElements";

const elementType = "chosen_installment";
function CardInstallmentElement({
  onChange,
  defaultValue = 1,
  placeholder = "Escolha o Parcelamento",
  required_message = "Selecione a opção de parcelamento.",
  installment_options = [],
}) {
  const form = Form.useFormInstance();
  const [_, setElements] = useElements();

  return (
    <Form.Item
      name={elementType}
      label={placeholder}
      initialValue={defaultValue}
      rules={[{ required: true, message: required_message }]}
    >
      <Select
        size="large"
        value={defaultValue}
        style={{ width: "auto", minWidth: 300 }}
        onChange={(installment) => {
          if (!onChange) return;
          setTimeout(() => {
            const errors = form.getFieldError(elementType);
            const payload = {
              elementType,
              [elementType]: installment,
              complete: errors.length <= 0,
              errors,
            };
            setElements((oldState) => ({
              ...oldState,
              [elementType]: payload,
            }));
            onChange(payload);
          }, 1);
        }}
        options={installment_options.map((item) => {
          const { installment, installment_price } = item;

          return {
            value: installment,
            label: `${installment}x de ${(installment_price || 0)
              .toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })
              .replace(".", ",")} ${installment === 1 ? "(à vista)" : ""}`,
          };
        })}
      />
    </Form.Item>
  );
}

export default CardInstallmentElement;
